
































































import Vue from "vue";
import { Component, Prop, Watch, Emit } from "vue-property-decorator";
import { Action } from "vuex-class";
import { DistributorModel, DistributorsClient, DsListEntryModel } from "@/diamond-support-api";

import { ErrorMessage, SuccessMessage } from "@/shared";

import {
  AssociateDataHelper,
  DiamondDataHelper,
  AssociateData,
  DiamondData,
} from "@/Helpers/DistributorDataHelper";

@Component
export default class DiamondNew extends Vue {
  @Action("showMessage", { namespace: "notification" }) showMessage: any;
  @Action("saveDiamondList", { namespace: "diamond" }) saveDiamondList: any;

  distributorDetail: DistributorModel | null = null;
  distributorApi = new DistributorsClient();

  associateDataHelper = new AssociateDataHelper();
  diamondDataHelper = new DiamondDataHelper();
  associateDetail: AssociateData | null = null;

  distributorId = "";

  search = "";
  lastSearchUpdate = 0;
  selectedId: string | null = null;
  loading = false;
  distributorDetails: DistributorModel[] = [];
  diamondListItemAdd: DiamondData | null = null;
  selectedItem: DsListEntryModel | null = null;
  diamondListItem: DsListEntryModel | null = null;
  adding = false;

  mounted() {}

  async add() {
    if (this.selectedItem === null) return;
    this.adding = true;
    await this.distributorApi
      .get(this.selectedItem.distributorId!)
      .then((response: DistributorModel) => {
        if (response && response.distributorId) {
          this.distributorDetail = response;
          this.diamondListItemAdd = this.diamondDataHelper.getDiamondList(
            this.distributorDetail
          );
          this.diamondListItemAdd.isSpaData = false;
          this.diamondListItem = <DsListEntryModel>this.diamondListItemAdd;
          this.emitAdded(this.diamondListItem!);
          this.adding = false;
        }
      })
      .catch((error: any) => {
        console.log("error", error);
      });

    this.shown = false;
    this.selectedItem = null;
  }

  @Watch("search")
  async onSearchChanged(val: string, oldVal: string) {
    if (!val) {
      this.distributorDetails = [];
      return;
    }
    this.loading = true;

    //reduce hits on the service
    this.lastSearchUpdate = new Date().getTime();

    let wait = (ms: number) =>
      new Promise((resolve) => setTimeout(resolve, ms));
    await wait(500);

    let now = new Date().getTime();

    if (now - this.lastSearchUpdate >= 500) {
      try {
        this.distributorDetails = await this.distributorApi.search(val, 1, 50);
        if (this.distributorDetails) this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    }
  }

  @Prop({ default: false }) shown!: boolean;

  @Emit("addConfirmed")
  emitAdded(item: DsListEntryModel) {
    return item;
  }

  @Emit("closed")
  emitClosed() {
    return true;
  }
}
